import styled from 'styled-components';

import { Field } from 'formik';
import { rem, themed } from '@/shared/ui/core';

export const SelectStyled = styled(Field)`
  font-size: ${themed('input.fontSize', rem)};
  color: ${themed('primary.text')};
  border: 1px solid ${themed('common.borderColor')};
  border-radius: ${rem(6)};
  padding: 0 0.75rem;
  height: 2.75rem;
  width: 100%;

  white-space: nowrap;
  text-overflow: ellipsis;

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='%23808080'><polygon points='15,30 85,30 50,70'/></svg>") no-repeat;
  background-size: 12px;
  background-position: calc(100% - 8px) center;
  background-repeat: no-repeat;
  background-color: ${themed('primary.background')};
`;
